import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class QuoteDeclinedReasonLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            reason: this.props.value || '',
            style: this.props.style || {},
        }
        this.className = this.props.className || ''
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            reason: nextProps.value || '',
            style: nextProps.style || {},
        })
    }

    renderStatus() {
        switch (this.state.reason) {
            case 'not-interested':
                return <FormattedMessage
                    id="quote.declined_reason.not_interested_label"
                    defaultMessage="Not interested by the products"
                />
            case 'too-expensive':
                return <FormattedMessage
                    id="quote.declined_reason.too_expensive_label"
                    defaultMessage="Too expensive"
                />
            case 'bought-somewhere-else':
                return <FormattedMessage
                    id="quote.declined_reason.bought_somewhere_else_label"
                    defaultMessage="Customer bought somewhere else"
                />
            case 'not-ready-to-buy':
                return <FormattedMessage
                    id="quote.declined_reason.not_ready_to_buy_label"
                    defaultMessage="Customer not ready to buy"
                />
            case 'too-long-delivery-time':
                return <FormattedMessage
                    id="quote.declined_reason.too_long_delivery_time_label"
                    defaultMessage="Too long delivery time"
                />
            case 'made-an-updated-offer':
                return <FormattedMessage
                    id="quote.declined_reason.made_an_updated_offer_label"
                    defaultMessage="Made an updated offer"
                />
            case 'expired':
                return <FormattedMessage
                    id="quote.declined_reason.expired_label"
                    defaultMessage="Expired"
                />
            default: return <span>{this.state.reason}</span>
        }
    }

    render() {
        return <span className={this.className} style={this.state.style}>
            {this.renderStatus()}
        </span>
    }

}

export default QuoteDeclinedReasonLabel





// WEBPACK FOOTER //
// ./src/quote/analytics/declinedreason.component.jsx